import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { TextArea } from '../../../../../components'

/**
 * Web Source
 */
class WebSource extends PureComponent {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const { values, onChange } = this.props

    return (
      <Grid item xs={9} container spacing={3}>
        <Grid item xs={12}>
          <div className='section_title'>Web Source</div>
        </Grid>

        <Grid item xs={12} container spacing={3}>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>LinkedIn URL</label>
              <TextArea
                id='linkedIn'
                value={values.linkedIn}
                onChange={onChange}
                maxlength={500}
                rows={5} />
            </div>
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Company Web Source 1</label>
              <TextArea
                id='website1'
                value={values.website1}
                onChange={onChange}
                maxlength={500}
                rows={5} />
            </div>
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Company Web Source 2</label>
              <TextArea
                id='website2'
                value={values.website2}
                onChange={onChange}
                maxlength={500}
                rows={5} />
            </div>
          </Grid>
        </Grid>

        <Grid item xs={12} container spacing={3}>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>FCA</label>
              <TextArea
                id='fca'
                value={values.fca}
                onChange={onChange}
                maxlength={500}
                rows={5} />
            </div>
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>SEC - ADV</label>
              <TextArea
                id='sec'
                value={values.sec}
                onChange={onChange}
                maxlength={500}
                rows={5} />
            </div>
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>FINRA</label>
              <TextArea
                id='finra'
                value={values.finra}
                onChange={onChange}
                maxlength={500}
                rows={5} />
            </div>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

WebSource.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default WebSource
